var React = require('react');

function IconDropdownArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M11.05.15a.5.5 0 01.77.63l-.05.07-5.8 5.93L.14.86A.5.5 0 01.8.09l.07.06 5.1 5.2 5.1-5.2z"}));
}

IconDropdownArrowInline.defaultProps = {"width":"12","height":"7"};

module.exports = IconDropdownArrowInline;

IconDropdownArrowInline.default = IconDropdownArrowInline;
